import { IntegrationType } from '../../data-access/gql-types/graphql';
import { environment } from '../../environment';
import { IntegrationDefaultEnum } from '../../types';

export const integrationTypeByIntegrationDefault = () => {
  return environment.INTEGRATION_DEFAULT === IntegrationDefaultEnum.Exalus
    ? IntegrationType.Exalus
    : IntegrationType.Lavva;
};
